<template>
	<div id="web" class="web">
		<div class="web-header flex-row-ac-jb">
			<div class="web-header-lt flex-row-ac-js">
				<router-link class="nav-button flex-row-ac-jc" tag="div" to="/home">
					<span class="nav-name">首页</span>
				</router-link>
				<router-link class="nav-button flex-row-ac-jc" tag="div" to="/gallery/list">
					<span class="nav-name">建筑图库</span>
				</router-link>
			</div>
			<div class="web-header-rt flex-row-ac-je">
				<router-link v-if="isLogin" class="nav-button flex-row-ac-jc" tag="div" to="/mine">
					<span class="nav-name">个人中心</span>
				</router-link>
				<router-link v-if="!isLogin" class="nav-button flex-row-ac-jc" tag="div" to="/login">
					<span class="nav-name">登录</span>
				</router-link>
				<div v-else class="nav-button flex-row-ac-jc" @click="handleLogout">
					<span class="nav-name">退出登录</span>
				</div>
			</div>
		</div>
		<div class="web-container flex-col-ac-jb">
			<router-view />
		</div>
	</div>
</template>

<script>
// import autofit from 'autofit.js';
export default {
  data() {
    return {
      // 仅保留必要的数据
    };
  },
  computed: {
    isLogin() {
      return this.$store.state.isLogin;
    }
  },
  created() {
    // 初始化登录状态
    const token = localStorage.getItem('token');
    const phone = localStorage.getItem('phone');
    if (token && phone) {
      this.$store.dispatch('login', {
        phone: phone,
        token: token
      });
    }
  },
  mounted() {
    // 初始化时调用必要的方法
  },
  methods: {
    // 退出登录方法
    handleLogout() {
    	this.$confirm('确定要退出登录吗？', '退出登录', {
    		confirmButtonText: '确定',
    		cancelButtonText: '取消',
    		type: 'warning'
    	}).then(() => {
    		this.doLogout();
    	}).catch(() => {
    		// 用户取消退出
    	})
    },
	doLogout() {
	  let params = {
	    phone: localStorage.getItem('phone')
	  };
	  console.log("--api.zhuxiao--参数");
	  console.log(params);
	  this.$http.zhuxiao(params).then((res) => {
	    console.log("--api.zhuxiao--结果");
	    console.log(res);
	    if (res.code != 0) {
	      this.$message.error(res.msg || `code: ${res.code}`);
	    } else {
	      // 清除localStorage中的用户信息
	      localStorage.removeItem('phone');
	      localStorage.removeItem('token');
	      // 更新Vuex状态
	      this.$store.dispatch('logout');
	      // 跳转到登录页
	      this.$router.push('/login');
	      // 显示退出登录成功提示
	      this.$message.success('已成功退出登录');
	    }
	  });
	}
  }
};
</script>

<style lang="scss">
	// 原有样式保持不变
	* {
		padding: 0;
		margin: 0;
		box-sizing: border-box;
	}

	#web {
		width: 100%;
	}

	.web {
		width: 100%;
		position: relative;
	}

	.web-header {
		z-index: 9;
		width: 100%;
		height: 50px;
		padding: 0 50px;
		position: fixed;
		top: 0;
		left: 0;
		background-color: #222222;
		box-sizing: border-box;
		/* 确保在滚动时保持在最上层 */
		z-index: 1000;

		&-lt,
		&-rt {}

		.nav-button {
			text-align: center;
			width: auto;
			height: 50px;
			padding: 0 20px;
			margin: 0 10px;
			cursor: pointer;

			// &:nth-of-type(4) {
			// 	margin-left: 1070rem;
			// }

			.nav-name {
				font-size: 15px;
				color: #FFFFFF;
			}

		}
	}

	a {
		text-decoration: none;
	}

	// flex布局
	.flex-row-ac-jc {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
	}

	.flex-row-ac-jb {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
	}

	.flex-row-ac-js {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
	}

	.flex-row-ac-je {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-end;
	}

	.flex-row-ae-js {
		display: flex;
		flex-direction: row;
		align-items: flex-end;
		justify-content: flex-start;
	}

	.flex-row-ae-jc {
		display: flex;
		flex-direction: row;
		align-items: flex-end;
		justify-content: center;
	}

	.flex-row-ae-jb {
		display: flex;
		flex-direction: row;
		align-items: flex-end;
		justify-content: space-between;
	}

	.flex-row-as-je {
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: flex-end;
	}

	.flex-row-as-jc {
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: center;
	}

	.flex-row-as-js {
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: flex-start;
	}

	.flex-row-as-jb {
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: space-between;
	}

	.flex-col-ac-jc {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.flex-col-ac-jb {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-between;
	}

	.flex-col-ac-js {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;
	}

	.flex-col-ac-je {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-end;
	}

	.flex-col-as-jc {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: center;
	}

	.flex-col-as-jb {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: space-between;
	}

	.flex-col-as-js {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: flex-start;
	}

	.flex-col-as-je {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: flex-end;
	}

	.flex-col-ae-js {
		display: flex;
		flex-direction: column;
		align-items: flex-end;
		justify-content: flex-start;
	}

	.flex-col-ae-jc {
		display: flex;
		flex-direction: column;
		align-items: flex-end;
		justify-content: center;
	}

	/* 当浏览器窗口宽度小于等于1280px时，网页不再继续缩小 */
	/* web-container 样式设置，使其内容可滚动 */
	.web-container {
		width: 100%;
		/* 减去header的高度并设置为视口高度减去header高度 */
		height: calc(100vh - 50px);
		margin-top: 50px;
		overflow-y: auto;
		/* 隐藏水平滚动条 */
		overflow-x: hidden;
	}

	@media screen and (max-width: 1280px) {

		#web,
		.web {
			min-width: 1280px;
			overflow-x: auto;
		}

		.web-header {
			min-width: 1280px;
		}
	}
</style>